import axios from "axios";

export async function axiosPost(endpoint, data = {}) {
  const apiConfig = {
    method: "POST",
    baseURL: `${process.env.REACT_APP_API_URL}`,
    mode: "cors",
    url: endpoint,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env.REACT_APP_ACCESS_TOKEN}`,
    },
    data
  };

  try {
    const response = await axios(apiConfig);
    if (response.status == 200)
      return response.data;
    else
      throw response.data
  } catch (error) {
    const errorResponse = error.response
    if (errorResponse.status && errorResponse.status === 401) {
    }
    return errorResponse.data
  }
};

const ApiCalls = (apiConfig) => {
  apiConfig.headers = {
    Authorization: `Bearer ${process.env.REACT_APP_ACCESS_TOKEN}`,
  };
  async function fetchData() {
    const response = await axios(apiConfig);
    return response;
  }
  return fetchData();
};

const ApiCalls2 = (apiConfig) => {
  apiConfig.headers = {
    Authorization: `Bearer ${process.env.REACT_APP_ACCESS_TOKEN}`,
  };

  return new Promise((resolve, reject) => {
    axios(apiConfig)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error("Request failed"));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export { ApiCalls, ApiCalls2 };
